import React from "react";
import PropTypes from "prop-types";
import { SIGNOL_COLOUR_NAMES } from "@signolteam/shared/colours";
import AppUtils from "@src/utils/appUtils";

const Progress = (props) => {
  const { color = "primary", percentage } = props;

  return (
    <div className="w-full h-4 bg-gray-100 rounded-md">
      <div
        className={`h-full rounded-md bg-${color}-500`}
        style={{ width: `${Math.floor(percentage * 100)}%` }}
      ></div>
    </div>
  );
};

export const progressControls = {
  color: {
    propType: PropTypes.string,
    controlType: "select",
    options: SIGNOL_COLOUR_NAMES,
    description: "Button color",
  },
  percentage: {
    propTypes: PropTypes.number.isRequired,
    controlType: "number",
    description: "Percentage for progress bar colour",
  },
};
Progress.propTypes = AppUtils.getPropTypeFromControls(progressControls);

export default Progress;
